import { ensureRouteData } from '@/app/query-client'
import { verifyCertificateQueryOptions } from '@/features/courses/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { parseCertificateCode } from '@/screens/courses/lib/params'

/**
 * The `/verify/$code` loader — a PUBLIC route: no session is needed, and
 * none is asked for (it sits under the `public` layout, outside the app's
 * auth gate).
 *
 * MAIN: the certificate for the code. `null` (`CERTIFICATE_NOT_FOUND`) is
 * the screen's "no such certificate" answer, not a failure.
 */
export async function loadVerifyCertificate({
  context: { queryClient },
  params,
}: {
  context: RouterContext
  params: { code: string }
}): Promise<void> {
  const code = parseCertificateCode(params.code)
  if (code === null) return
  await ensureRouteData(queryClient, verifyCertificateQueryOptions(code))
}
